import { render, staticRenderFns } from "./DatasetPropertiesSymbology.vue?vue&type=template&id=3d38f7f4&"
import script from "./DatasetPropertiesSymbology.vue?vue&type=script&lang=js&"
export * from "./DatasetPropertiesSymbology.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./DatasetPropertiesSymbology.vue?vue&type=custom&index=0&blockType=symbology&scoped=true"
if (typeof block0 === 'function') block0(component)

export default component.exports